import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ContentLayoutComponent } from './components/layout/content-layout/content-layout.component';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
//Componentes prin NETSOLIN
import { HeaderMonitornetComponent } from './components/header-monitornet/header-monitornet.component';
//KENDO
import { LayoutModule } from "@progress/kendo-angular-layout";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { SliderModule } from "@progress/kendo-angular-inputs";

// services
import { NavService } from "./services/nav.service";
import { CustomizerService } from "./services/customizer.service";
// Directives
import { ToggleFullscreenDirective } from "./directives/fullscreen.directive";
import { TextboxFormQuestionComponent } from './components/dynamic-form/textbox-form-question.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { DropDownFormQuestionComponent } from './components/dynamic-form/dropdown-question.component';
import { MultiSelectFormQuestionComponent } from './components/dynamic-form/multiselect-question.component';
import { NumerictextboxFormQuestionComponent } from './components/dynamic-form/numerictextbox-form-question.component';
import { CheckboxFormQuestionComponent } from './components/dynamic-form/checkbox-form-question.component';
import { TextareaFormQuestionComponent } from './components/dynamic-form/textarea-form-question.component';
import { DatepickerFormQuestionComponent } from './components/dynamic-form/datepicker-form-question.component';
import { UserSidebarComponent } from './components/user-sidebar/user-sidebar.component';
import { NgToggleModule } from 'ng-toggle-button';
import { ErpComponent } from './components/layout/erp/erp.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderMonitornetComponent,
    FooterComponent,
    SidebarComponent,
    UserSidebarComponent,
    ContentLayoutComponent,
    FeatherIconsComponent,
    BreadcrumbComponent,
    ToggleFullscreenDirective,
    TextboxFormQuestionComponent,DynamicFormComponent,
    DropDownFormQuestionComponent,NumerictextboxFormQuestionComponent,CheckboxFormQuestionComponent, TextareaFormQuestionComponent,
    DatepickerFormQuestionComponent, MultiSelectFormQuestionComponent, ErpComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    ButtonsModule,
    InputsModule,
    LabelModule,
    DateInputsModule,
    DropDownsModule,
    SliderModule,
    NgToggleModule,
    AngularSvgIconModule
  ],
  exports: [
    FeatherIconsComponent,
    HeaderMonitornetComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    TextboxFormQuestionComponent, DynamicFormComponent,
    DropDownFormQuestionComponent, NumerictextboxFormQuestionComponent, CheckboxFormQuestionComponent, TextareaFormQuestionComponent,
    DatepickerFormQuestionComponent
  ],
  providers: [
    NavService,
    CustomizerService
  ]
})
export class SharedModule { }

